import { get } from '../../base';

import { TaxRateCategoriesResponse } from './types';

export function getTaxRatesForCategories(marketId: string) {
  return get('v5/tax-rates/categories', { searchParams: { marketId } }).json<TaxRateCategoriesResponse>();
}
